export default {"src":"/_next/static/media/arrow-right.92b6eea4.svg","height":21,"width":20,"blurWidth":0,"blurHeight":0};